import type { ReactNode } from 'react';
import { SiteIcon } from './SiteBrand';

export function WorkspaceHeader({ title, reference, backLabel, onBack, busy = false, children, inspection = false, home = false }: {
  title: string; reference?: string | undefined; backLabel: string; onBack: () => void;
  busy?: boolean; children: ReactNode; inspection?: boolean; home?: boolean;
}) {
  return <header className={`workspace-header ${inspection ? 'snag-project-header' : 'topbar compact-header'}`}>
    <div className="workspace-heading">{home ? <span className="workspace-home-icon"><SiteIcon name="projects" /></span> : <button type="button" aria-label={backLabel} disabled={busy} onClick={onBack}><SiteIcon name="back" /></button>}<div><strong>{title}</strong>{reference && <small>{reference}</small>}</div></div>
    <div className="workspace-header-tools">{children}</div>
  </header>;
}
